import { render, staticRenderFns } from "./LongDistanceServices.vue?vue&type=template&id=5fa7b680&scoped=true&"
import script from "./LongDistanceServices.vue?vue&type=script&lang=js&"
export * from "./LongDistanceServices.vue?vue&type=script&lang=js&"
import style0 from "./LongDistanceServices.vue?vue&type=style&index=0&id=5fa7b680&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa7b680",
  null
  
)

export default component.exports